import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "tasks priority" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M3 9.33398C2.44772 9.33398 2 9.7817 2 10.334V13.0007C2 13.5529 2.44772 14.0007 3 14.0007H4.11333C4.66562 14.0007 5.11333 13.5529 5.11333 13.0007V10.334C5.11333 9.7817 4.66562 9.33398 4.11333 9.33398H3Z",
    fill: "#1E1F24"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_2",
    d: "M7.44659 5.66724C6.89431 5.66724 6.44659 6.11495 6.44659 6.66724V13.0006C6.44659 13.5529 6.89431 14.0006 7.44659 14.0006H8.55993C9.11221 14.0006 9.55993 13.5529 9.55993 13.0006V6.66724C9.55993 6.11495 9.11221 5.66724 8.55993 5.66724H7.44659Z",
    fill: "#CDCED7"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_3",
    d: "M10.8932 3.00073C10.8932 2.44845 11.341 2.00073 11.8932 2.00073H13.0066C13.5589 2.00073 14.0066 2.44845 14.0066 3.00073V13.0007C14.0066 13.553 13.5589 14.0007 13.0066 14.0007H11.8933C11.341 14.0007 10.8932 13.553 10.8932 13.0007V3.00073Z",
    fill: "#CDCED7"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }